// extracted by mini-css-extract-plugin
module.exports = {"marquee":"Marquee_marquee__tIqKu"};